import React, { useEffect, useState } from 'react';

import { Container, Grid, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import AccountPersonalDetails from '../../components/patientAccount/AccountPersonalDetails';
import AccountPlan from '../../components/patientAccount/AccountPlan';
import useBlocRef from '../../utils/useBlocRef.hook';

export default () => {
  const blocRef = useBlocRef('patientAccountBloc');
  const [details, setDetails] = useState({});

  useEffect(() => {
    const detailsSub = blocRef.current.details$.subscribe(setDetails);

    try {
      blocRef.current.getCurrentUser();
    } catch (ignore) {
      //
    }

    return () => {
      detailsSub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const history = useHistory();
  const handleUpdateDetails = () => blocRef.current.openUpdateDialog();
  const handleChangePassword = () => blocRef.current.openChangePasswordDialog();
  const handleCancelPlan = () => blocRef.current.openCancelPlanDialog();
  const handleOpenChangeEmail = () => blocRef.current.openChangeEmailDialog();
  const handleUpgrade = () => history.push('/upgrade-plan?action=upgrade');

  return (
    <Grid container component={Container} style={{ display: 'flex' }} className="pt-2 pb-2 text-left">
      <Grid item xs={12} container>
        <Grid item xs={12}>
          <Typography className="page-header mb-1">My Account</Typography>
        </Grid>
        <Grid item md={5} xs={12}>
          <Typography className="body-copy mb-2">
            Update your details, change your password or change your current plan. Note that once a password is changed it might take a few minutes to reflect on our system.
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={12} container>
        <Grid item xs={12} className="mb-3">
          <AccountPersonalDetails details={details} onUpdate={handleUpdateDetails} onChangeEmail={handleOpenChangeEmail} onChangePassword={handleChangePassword} />
        </Grid>
        <Grid item xs={12} className="mb-2">
          {details?.userPlan?.id && <AccountPlan details={details} onUpgrade={handleUpgrade} onCancelPlan={handleCancelPlan} />}
        </Grid>
      </Grid>
    </Grid>
  );
};
